import { ExperienceType } from "@/generated/graphql";
import { EventCategory } from "@/services/tracking/tracking-types";

export function getEventCategoryFromExperienceType(
  experienceType?: ExperienceType,
): EventCategory {
  if (!experienceType) {
    return EventCategory.Channels;
  }

  switch (experienceType) {
    case ExperienceType.Show:
      return EventCategory.Show;
    case ExperienceType.Thread:
      return EventCategory.Threads;
    default:
      return EventCategory.Channels;
  }
}
